import { Collapse, Icon, PopoverPosition } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import classNames from 'classnames';
import * as React from 'react';
import { Tooltip } from 'vet-bones/components';

import * as copy from 'src/templates/copy';

type AdvancedOptionsProps = {
  buttonTestId?: string;
  buttonTooltipText?: string;
  children?: React.ReactNode;
  className?: string;
  rightElement?: JSX.Element;
  text?: (isOpen: boolean) => string;
};

export const AdvancedOptions: React.VFC<AdvancedOptionsProps> = ({
  buttonTestId,
  buttonTooltipText,
  children,
  className,
  rightElement,
  text = () => copy.components.defaults.advancedOptions,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <div className={classNames('sd-advanced-options', className)}>
      <Tooltip
        content={buttonTooltipText || ''}
        disabled={!buttonTooltipText}
        position={PopoverPosition.TOP}
      >
        <div className="sd-advanced-options__button">
          <a
            data-testid={buttonTestId}
            onClick={() => setIsOpen(!isOpen)}
            role="button"
            tabIndex={0}
          >
            <Icon
              icon={isOpen ? IconNames.CARET_DOWN : IconNames.CARET_RIGHT}
            />
            {text(isOpen)}
          </a>
          {rightElement}
        </div>
      </Tooltip>
      <Collapse isOpen={isOpen}>{children}</Collapse>
    </div>
  );
};
